<template>
  <div class="top-wrap">
    <div class="top w">
      <div class="left">
        <span>{{this.currentDate + ' ' + this.currentWeekday}}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    bgcolor: {
      type: String,
    },
    isShowHome: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      locationInfo: null, //定位
      scCustom: {}, //用户信息
      loginStatus: false,
      locationVisible: false,

      currentDate: '',
      currentWeekday: ''
    };
  },
  created() {
    this.getCurrentDate();
    this.getCurrentWeekday();
    this.fetchData();
  },
  methods: {
    fetchData() { },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const date = today.getDate();
      this.currentDate = `${year}年${month}月${date}日`;
    },
    getCurrentWeekday() {
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      const today = new Date();
      const weekdayIndex = today.getDay();
      this.currentWeekday = weekdays[weekdayIndex];
    }
  }
};
</script>

<style lang="scss" scoped>
.top-wrap {
  // background: linear-gradient(to bottom, #f2f2f2, #f7f7f7);
  background: #fff;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;

  .left {
    display: flex;
    align-items: center;
    padding-right: 12px;
    font-size: 14px;
    cursor: pointer;
    color: #989898;

    .icon {
      font-size: 16px;
      margin-right: 4px;
    }

    .link {
      margin-left: 20px;
      color: #989898;
    }
  }

  .right {
    display: flex;
    align-items: center;

    .item {
      padding: 0 8px;
      font-size: 16px;
      color: #0f0f0f;
    }
    .el-dropdown {
      margin: 0 10px;
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #989898;
    }

    .btn-item {
      color: #989898;
      padding: 0 0.35em;
      cursor: pointer;
    }
    .btn-item:hover {
      text-decoration: underline;
    }

    .item:last-child {
      cursor: pointer;
    }

    .contact {
      position: relative;

      .icon {
        font-size: 14px;
        margin-right: 4px;
        color: #597af8;
      }

      .contact-box {
        position: absolute;
        top: 32px;
        right: -20px;
        padding: 16px 24px 24px;
        display: none;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border-radius: 6px;
        z-index: 10;
        box-shadow: 8px 8px 12px rgba(0, 0, 0, 0.08);

        .triangle {
          position: absolute;
          top: -24px;
          right: 45px;
          transform: translate(-50%, 0);
          border: 12px solid #fff;
          border-color: transparent transparent #fff transparent;
        }

        .title {
          margin-bottom: 12px;
          text-align: center;
          font-size: 14px;
          color: #000;
        }

        .contact-wrap {
          display: flex;
          flex-direction: column;

          .img-wrap {
            width: 252px;
            height: 252px;
            overflow: hidden;
            border-radius: 6px;
          }

          .subtitle {
            margin: 12px 0;
            text-align: center;
            font-size: 14px;
            color: #333;
          }

          .phone {
            text-align: center;
            font-size: 14px;
            color: #333;
          }
        }
      }
    }

    .contact:hover .contact-box {
      display: flex;
    }
  }
}
</style>
